import { privateApi } from 'services';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';
import {
    CreateSegmentRequest,
    EvaluateSegmentResponse,
    PreviewSegmentSizeRequest,
    PreviewSegmentSizeResponse,
    TalentSegment,
    UpdateSegmentRequest,
} from './types';

const archive = (segmentId: string): Promise<void> =>
    privateApi.post<void>(`segments/${segmentId}/archive`, undefined, {}, true);

const unarchive = (segmentId: string): Promise<void> =>
    privateApi.post<void>(`segments/${segmentId}/unarchive`, undefined, {}, true);

const create = (businessAccountId: string, segment: CreateSegmentRequest): Promise<void> =>
    privateApi.post<void>(`business-accounts/${businessAccountId}/leads/segments`, segment);

const update = (segmentId: string, segment: UpdateSegmentRequest): Promise<void> =>
    privateApi.put<void>(`segments/${segmentId}`, segment);

const evaluate = (segmentId: string): Promise<EvaluateSegmentResponse> =>
    privateApi.post<EvaluateSegmentResponse>(`segments/${segmentId}/evaluate`, undefined, {}, true);

const previewSize = (
    businessAccountId: string,
    request: PreviewSegmentSizeRequest,
): Promise<PreviewSegmentSizeResponse> =>
    privateApi.post<PreviewSegmentSizeResponse>(
        `business-accounts/${businessAccountId}/leads/segments/preview-size`,
        request,
    );

const previewSizeRefresh = (
    businessAccountId: string,
    request: PreviewSegmentSizeRequest,
): Promise<PreviewSegmentSizeResponse> =>
    privateApi.post<PreviewSegmentSizeResponse>(
        `business-accounts/${businessAccountId}/leads/segments/preview-size-refresh`,
        request,
    );

export const SegmentGateway = {
    archive,
    unarchive,
    create,
    update,
    evaluate,
    previewSize,
    previewSizeRefresh,
};

const cancelableFetchSegment = (segmentId: string): Promise<TalentSegment> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<TalentSegment>(`segments/${segmentId}`);

const cancelableFetchSegments = (businessAccountId: string): Promise<TalentSegment[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<TalentSegment[]>(
        `business-accounts/${businessAccountId}/leads/segments`,
    );

export const CancelableSegmentGateway = {
    cancelableFetchSegment,
    cancelableFetchSegments,
};
